import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import type { ModuloWeb } from '../../nucleo/modulos';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import { dicionario } from './i18n';
import { formatarDinheiro } from './tipos';

/**
 * F10: produtos abaixo do mínimo (destaque), valor em estoque e lotes vencendo em 30 dias. ROB-01: cartões do núcleo
 * (CartaoIndicador), que mostram o traço e "Tentar de novo" quando a API falha, em vez de "..." para sempre.
 */
function Indicadores() {
  const { t, i18n } = useTranslation('estoque');
  const q = useQuery({ queryKey: ['estoque', 'resumo'], queryFn: () => api<{ produtos: number; abaixo_minimo: number; valor_centavos: string; lotes_vencendo: number }>('/api/v1/estoque/resumo') });
  const destaque = (n: number) => <span className={n > 0 ? 'text-laranja' : ''}>{n}</span>;
  return (
    <>
      <CartaoIndicador rotulo={t('indicadores.abaixo')} valor={q.data ? destaque(q.data.abaixo_minimo) : null} consultas={[q]} />
      <CartaoIndicador rotulo={t('indicadores.valor')} valor={q.data ? <span className="break-words">{formatarDinheiro(q.data.valor_centavos, 'BRL', i18n.language)}</span> : null} consultas={[q]} />
      <CartaoIndicador rotulo={t('indicadores.vencendo')} valor={q.data ? destaque(q.data.lotes_vencendo) : null} consultas={[q]} />
    </>
  );
}

const carregar0 = () => import('./Produtos');
const carregar1 = () => import('./FichaProduto');
const carregar2 = () => import('./VariacoesUnidades');
const carregar3 = () => import('./Depositos');
const carregar4 = () => import('./Movimentacoes');
const carregar5 = () => import('./Reposicao');
const carregar6 = () => import('./Inventarios');
const carregar7 = () => import('./Lotes');

const AcaoProdutos = acaoSobDemanda(carregar0, 'AcaoProdutos');
const ListaProdutos = telaSobDemanda(carregar0, 'ListaProdutos');
const FichaProduto = telaSobDemanda(carregar1, 'FichaProduto');
const AcaoVariacoes = acaoSobDemanda(carregar2, 'AcaoVariacoes');
const VariacoesUnidades = telaSobDemanda(carregar2, 'VariacoesUnidades');
const AcaoDepositos = acaoSobDemanda(carregar3, 'AcaoDepositos');
const Depositos = telaSobDemanda(carregar3, 'Depositos');
const AcaoMovimentacoes = acaoSobDemanda(carregar4, 'AcaoMovimentacoes');
const ListaMovimentacoes = telaSobDemanda(carregar4, 'ListaMovimentacoes');
const AcaoReposicao = acaoSobDemanda(carregar5, 'AcaoReposicao');
const Reposicao = telaSobDemanda(carregar5, 'Reposicao');
const AcaoInventarios = acaoSobDemanda(carregar6, 'AcaoInventarios');
const FichaInventario = telaSobDemanda(carregar6, 'FichaInventario');
const Inventarios = telaSobDemanda(carregar6, 'Inventarios');
const Lotes = telaSobDemanda(carregar7, 'Lotes');

export const modulo: ModuloWeb = {
  slug: 'estoque',
  menu: 'operacao',
  dicionario,
  abas: [
    { rotulo: 'abas.produtos', caminho: 'produtos', elemento: <ListaProdutos />, Acao: AcaoProdutos, ordem: 1 },
    { rotulo: 'abas.variacoes', caminho: 'variacoes-e-unidades', elemento: <VariacoesUnidades />, Acao: AcaoVariacoes, ordem: 2 },
    { rotulo: 'abas.depositos', caminho: 'depositos', elemento: <Depositos />, Acao: AcaoDepositos, ordem: 3 },
    { rotulo: 'abas.movimentacoes', caminho: 'movimentacoes', elemento: <ListaMovimentacoes />, Acao: AcaoMovimentacoes, ordem: 4 },
    { rotulo: 'abas.reposicao', caminho: 'reposicao', elemento: <Reposicao />, Acao: AcaoReposicao, ordem: 5 },
    { rotulo: 'abas.inventario', caminho: 'inventario', elemento: <Inventarios />, Acao: AcaoInventarios, ordem: 6 },
    { rotulo: 'abas.lotes', caminho: 'lotes-e-validade', elemento: <Lotes />, ordem: 7 },
  ],
  rotas: [
    { path: 'operacao/produto/:id', element: <FichaProduto /> },
    { path: 'operacao/inventario/:id', element: <FichaInventario /> },
  ],
  Indicadores,
};
